import { atomWithReset } from "jotai/utils";
export const activeTabAtom = atomWithReset("DESIGN");
